import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { ReportsListComponent } from './components/reports-list/reports-list.component';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [ReportsComponent, ReportsListComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class ReportsModule { }
